import { createRoutine } from 'redux-saga-routines';
import * as type from './type';

const setProgressBar = createRoutine(type.SET_PROGRESSBAR);
const addProgressBar = createRoutine(type.ADD_PROGRESSBAR);
const removeProgressBar = createRoutine(type.REMOVE_PROGRESSBAR);

const setSnackBar = createRoutine(type.SET_SNACKBAR);
const closeSnackBar = createRoutine(type.CLOSE_SNACKBAR);
const setDialog = createRoutine(type.SET_DIALOG);

const setMenuType = createRoutine(type.SET_MENU_TYPE);
const errorPopup = createRoutine(type.ERROR_POPUP);

/**
 * 공통코드 관련 액션
 */
const getCode = createRoutine(type.GET_CODE);
const initCode = createRoutine(type.INIT_CODE);

/**
 * 공통
 */
const initCheckElement = createRoutine(type.INIT_CHECK_ELEMENT);

/**
 * 인보이스 관련 액션
 */
const initInvoice = createRoutine(type.INIT_INVOICE);
const setIssueInfo = createRoutine(type.SET_ISSUE_INFO);

const getInvoice = createRoutine(type.GET_INVOICE);
const getInvoiceList = createRoutine(type.GET_INVOICE_LIST);
const setInvoiceList = createRoutine(type.SET_INVOICE_LIST);
const setInvoiceListTotalAmount = createRoutine(
  type.SET_INVOICE_LIST_TOTAL_AMOUNT
);
const getInvoiceIssusanceList = createRoutine(type.GET_INVOICE_ISSUANCE_LIST);
const getInvoiceInquiryByCase = createRoutine(type.GET_INVOICE_INQUIRY_BY_CASE);
const isInvoiceSearchView = createRoutine(type.IS_INVOICE_SEARCH_VIEW);
const getInvoiceDetail = createRoutine(type.GET_INVOICE_DETAIL);
const getCopyCorrectionInvoiceDetail = createRoutine(
  type.GET_COPY_CORRECTION_INVOICE_DETAIL
);
const isInvoiceDetailPopup = createRoutine(type.IS_INVOICE_DETAIL_POPUP);
const getCopyIssueInvoiceList = createRoutine(type.GET_COPY_ISSUE_INVOICE_LIST);
const getInvoiceTempList = createRoutine(type.GET_INVOICE_TEMP_LIST);
const getInvoiceCorrectList = createRoutine(type.GET_INVOICE_CORRECT_LIST);
const getInvoiceCorrectDetail = createRoutine(type.GET_INVOICE_CORRECT_DETAIL);
const initInvoiceCorrectDetail = createRoutine(
  type.INIT_INVOICE_CORRECT_DETAIL
);
const getInvoiceEmailHistory = createRoutine(type.GET_INVOICE_EMAIL_HISTORY);
const postInvoiceEmailResend = createRoutine(type.POST_INVOICE_EMAIL_RESEND);
const setIssuanceInvoiceList = createRoutine(type.SET_ISSUANCE_INVOICE_LIST);
const setInvoiceIssue = createRoutine(type.SET_INVOICE_ISUUE);
const setPreviewInvoiceIssue = createRoutine(type.SET_PREVIEW_INVOICE_ISUUE);
const setInvoiceSave = createRoutine(type.SET_INVOICE_SAVE);
const deleteInvoiceTempList = createRoutine(type.DELETE_INVOICE_TEMP_LIST);

const getInvoicePosIssuanceList = createRoutine(
  type.GET_INVOICE_POS_ISSUANCE_LIST
);
const getInvoicePosInquiryByCase = createRoutine(
  type.GET_INVOICE_POS_INQUIRY_BY_CASE
);

const getIssueInvoiceDetail = createRoutine(type.GET_ISSUE_INVOICE_DETAIL);

const invoiceIssueInfo = createRoutine(type.INVOICE_ISSUE_INFO);
const initInvoiceIssueInfo = createRoutine(type.INIT_INVOICE_ISSUE_INFO);
const invoiceCheckIssuePopup = createRoutine(type.INVOICE_CHECK_ISSUE_POPUP);
const invoicePreviewPopup = createRoutine(type.INVOICE_PREVIEW_POPUP);
const invoiceSavePopup = createRoutine(type.INVOICE_SAVE_POPUP);
const invoiceSaveCompletePopup = createRoutine(
  type.INOVICE_SAVE_COMPLETE_POPUP
);
const invoiceIssueCompletePopup = createRoutine(
  type.INOVICE_ISSUE_COMPLETE_POPUP
);
const isInvoiceInit = createRoutine(type.IS_INVOICE_INIT);

const getMassiveIssuanceVerificationResult = createRoutine(
  type.GET_MASSIVE_ISSUANCE_VERIFICATION_RESULT
);

const updateMassiveIssuance = createRoutine(type.UPDATE_MASSIVE_ISSUANCE);
const setMassiveInvoiceTempList = createRoutine(
  type.SET_MASSIVE_INVOICE_TEMP_LIST
);
/**
 * 클라이언트 관련 액션
 */
const getClientList = createRoutine(type.GET_CLIENT_LIST);
const setClientList = createRoutine(type.SET_CLIENT_LIST);
const insertClientList = createRoutine(type.INSERT_CLIENT_LIST);
const deleteClientList = createRoutine(type.DELETE_CLIENT_LIST);
const updateClient = createRoutine(type.UPDATE_CLIENT);
const setUploadClientList = createRoutine(type.SET_UPLOAD_CLIENT_LIST);
const isClientDetailPopup = createRoutine(type.IS_CLIENT_DETAIL_POPUP);
const insertUploadClientList = createRoutine(type.INSERT_UPLOAD_CLIENT_LIST);
const initClientList = createRoutine(type.INIT_CLIENT_LIST);

const getClientStatus = createRoutine(type.GET_CLIENT_STATUS);
const isTradeTin = createRoutine(type.IS_TRADE_TIN);
const tradeTinCheck = createRoutine(type.TRADE_TIN_CHECK);
const isTradeTinCheck = createRoutine(type.IS_TRADE_TIN_CHECK);
const tradeRegisteredNameCheck = createRoutine(type.TRADE_REGISTEREDAME_CHECK);
const isTradeRegisteredNameCheck = createRoutine(
  type.IS_TRADE_REGISTERED_NAME_CHECK
);
/**
 * 아이템 관련 액션
 */
const getItemList = createRoutine(type.GET_ITEM_LIST);
const setItemList = createRoutine(type.SET_ITEM_LIST);
const insertItemList = createRoutine(type.INSERT_ITEM_LIST);
const deleteItemList = createRoutine(type.DELETE_ITEM_LIST);
const updateItem = createRoutine(type.UPDATE_ITEM);
const setUploadItemList = createRoutine(type.SET_UPLOAD_ITEM_LIST);
const isItemDetailPopup = createRoutine(type.IS_ITEM_DETAIL_POPUP);
const insertUploadItemList = createRoutine(type.INSERT_UPLOAD_ITEM_LIST);
const initItemList = createRoutine(type.INIT_ITEM_LIST);
const itemNameCheck = createRoutine(type.ITEM_NAME_CHECK);
const isItemNameCheck = createRoutine(type.IS_ITEM_NAME_CHECK);
/**
 * 노티스 관련 액션
 */
const getAdvisoryList = createRoutine(type.GET_ADVISORY_LIST);
const getAdvisoryDetail = createRoutine(type.GET_ADVISORY_DETAIL);
const insertAdvisoryList = createRoutine(type.INSERT_ADVISORY_LIST);
const initAdvisoryList = createRoutine(type.INIT_ADVISORY_LIST);
const initAdvisoryDetail = createRoutine(type.INIT_ADVISORY_DETAIL);
const setAdvisoryPage = createRoutine(type.SET_ADVISORY_PAGE);
const getMainAdvisoryList = createRoutine(type.GET_MAIN_ADVISORY_LIST);

/**
 * BOARD 관련 액션
 */
const getBoardList = createRoutine(type.GET_BOARD_LIST);
const getBoardDetail = createRoutine(type.GET_BOARD_DETAIL);
const initBoardList = createRoutine(type.INIT_BOARD_LIST);
const initBoardDetail = createRoutine(type.INIT_BOARD_DETAIL);
const insertBoardPostList = createRoutine(type.INSERT_BOARD_POST_LIST);
const setFaqPage = createRoutine(type.SET_FAQ_PAGE);

/**
 * ObjectStorage 관련 타입
 */
const objectStorageUpload = createRoutine(type.OBJECTSTORAGE_UPLOAD);
const objectStorageDownload = createRoutine(type.OBJECTSTORAGE_DOWNLOAD);
const objectStorageDelete = createRoutine(type.OBJECTSTORAGE_DELETE);
const objectStorageAlwaysDownloadUrl = createRoutine(
  type.OBJECTSTORAGE_ALWAYSDOWNLOAD_URL
);
const templateDownload = createRoutine(type.TEMPLATE_DOWNLOAD);

/**
 * 계정 관련 액션
 */
const findByAuthorization = createRoutine(type.FIND_BY_AUTHORIZATION);
const insertUser = createRoutine(type.INSERT_USER);
const getEncryptPasswordKey = createRoutine(type.GET_PW_ENCRYPT_KEY);
const isTin = createRoutine(type.IS_TIN);
const isTinBranchCodeChange = createRoutine(type.IS_TIN_BRANCHCODE_CHANGE);
const existId = createRoutine(type.EXIST_ID);
const destroySignUpElement = createRoutine(type.DESTROY_SIGNUP_ELEMENT);

const signIn = createRoutine(type.SIGN_IN);
const signOut = createRoutine(type.SIGN_OUT);

const searchId = createRoutine(type.SEARCH_ID);
const sendSearchIdMail = createRoutine(type.SEND_MAIL_SEARCH_ID);
const searchPw = createRoutine(type.SEARCH_PW);
const sendSearchPwMail = createRoutine(type.SEND_MAIL_SEARCH_PW);

const changePassword = createRoutine(type.CHANGE_PASSWORD);
const changePasswordByDialog = createRoutine(type.CHANGE_PASSWORD_BY_DIALOG);
const resetPassword = createRoutine(type.RESET_PASSWORD);
const initUser = createRoutine(type.INIT_USER);

const getUser = createRoutine(type.GET_USER);
const updateUser = createRoutine(type.UPDATE_USER);

const searchUserList = createRoutine(type.SEARCH_USER_LIST);
const changeUserStatus = createRoutine(type.CHANGE_USER_STATUS);

const initMail = createRoutine(type.INIT_MAIL);

/**
 * 통계 관련 액션
 */
const initStatistics = createRoutine(type.INIT_STATISTICS);
const getStatisticsSum = createRoutine(type.GET_STATISTICS_SUM);
const getStatisticsSumDetail = createRoutine(type.GET_STATISTICS_SUM_DETAIL);
const getStatisticsSumPopup = createRoutine(type.GET_STATISTICS_SUM_POPUP);
const getStatisticsPeriod = createRoutine(type.GET_STATISTICS_PERIOD);
const getStatisticsPeriodDetail = createRoutine(
  type.GET_STATISTICS_PERIOD_DETAIL
);
const getStatisticsPeriodPopup = createRoutine(
  type.GET_STATISTICS_PERIOD_POPUP
);
const getStatisticsType = createRoutine(type.GET_STATISTICS_TYPE);
const isStatisticsSumPopup = createRoutine(type.IS_STATISTICS_SUM_POPUP);
const isStatisticsPeriodPopup = createRoutine(type.IS_STATISTICS_PERIOD_POPUP);

const initStatisticsPosCrm = createRoutine(type.INIT_STATISTICS_POSCRM);
const getStatisticsPosCrmSum = createRoutine(type.GET_STATISTICS_POSCRM_SUM);
const getStatisticsPosCrmSumDetail = createRoutine(
  type.GET_STATISTICS_POSCRM_SUM_DETAIL
);
const getStatisticsPosCrmSumPopup = createRoutine(
  type.GET_STATISTICS_POSCRM_SUM_POPUP
);
const getStatisticsPosCrmPeriod = createRoutine(
  type.GET_STATISTICS_POSCRM_PERIOD
);
const getStatisticsPosCrmPeriodDetail = createRoutine(
  type.GET_STATISTICS_POSCRM_PERIOD_DETAIL
);
const getStatisticsPosCrmPeriodPopup = createRoutine(
  type.GET_STATISTICS_POSCRM_PERIOD_POPUP
);
const getStatisticsPosCrmType = createRoutine(type.GET_STATISTICS_POSCRM_TYPE);
const isStatisticsPosCrmSumPopup = createRoutine(
  type.IS_STATISTICS_POSCRM_SUM_POPUP
);
const isStatisticsPosCrmPeriodPopup = createRoutine(
  type.IS_STATISTICS_POSCRM_PERIOD_POPUP
);

/**
 * 회사 관련 액션
 */
const initCompany = createRoutine(type.INIT_COMPANY);
const getCompany = createRoutine(type.GET_COMPANY);
const getCompanyByTinAndBranchCode = createRoutine(
  type.GET_COMPNAY_BY_TIN_AND_BRANCHCODE
);
const updateCompany = createRoutine(type.UPDATE_COMPANY);
const updateInvoiceSetting = createRoutine(type.UPDATE_INVOICE_SETTING);
const deleteEmployee = createRoutine(type.DELETE_EMPLOYEE);
const inviteEmployee = createRoutine(type.INVITE_EMPLOYEE);

const initTaxpayerDetail = createRoutine(type.INIT_TAXPAYER_DETAIL);
const getTaxpayerDetail = createRoutine(type.GET_TAXPAYER_DETAIL);

/**
 * VAT 관련 액션
 */
const initVatMonthlyList = createRoutine(type.INIT_VAT_MONTHLY_LIST);
const initVatMonthlyDetail = createRoutine(type.INIT_VAY_MONTHLY_DETAIL);
const initVatQuarterlyList = createRoutine(type.INIT_VAT_QUARTERLY_LIST);
const initVatQuarterlyDetail = createRoutine(type.INIT_VAT_QUARTERLY_DETAIL);
const getVatMonthlyList = createRoutine(type.GET_VAT_MONTHLY_LIST);
const getVatMonthlyDetail = createRoutine(type.GET_VAY_MONTHLY_DETAIL);
const getVatQuarterlyList = createRoutine(type.GET_VAT_QUARTERLY_LIST);
const getVatQuarterlyDetail = createRoutine(type.GET_VAT_QUARTERLY_DETAIL);

/**
 * JWS 관련 액션
 */
const initJWS = createRoutine(type.INIT_JWS);
const getJWS = createRoutine(type.GET_JWS);
export default {
  setProgressBar,
  addProgressBar,
  removeProgressBar,
  setSnackBar,
  closeSnackBar,
  setDialog,

  setMenuType,
  errorPopup,

  getCode,
  initCode,

  initCheckElement,
  templateDownload,

  initInvoice,
  setIssueInfo,
  getInvoice,
  getInvoiceList,
  setInvoiceList,
  setInvoiceListTotalAmount,
  getInvoiceIssusanceList,
  getInvoiceInquiryByCase,
  isInvoiceSearchView,
  getInvoiceDetail,
  getCopyCorrectionInvoiceDetail,
  isInvoiceDetailPopup,
  getCopyIssueInvoiceList,
  getInvoiceTempList,
  getInvoiceCorrectList,
  getInvoiceCorrectDetail,
  initInvoiceCorrectDetail,
  getInvoiceEmailHistory,
  postInvoiceEmailResend,
  setIssuanceInvoiceList,
  setInvoiceIssue,
  setPreviewInvoiceIssue,
  setInvoiceSave,
  deleteInvoiceTempList,

  getInvoicePosIssuanceList,
  getInvoicePosInquiryByCase,

  getIssueInvoiceDetail,

  invoiceIssueInfo,
  initInvoiceIssueInfo,
  invoiceCheckIssuePopup,
  invoicePreviewPopup,
  invoiceSavePopup,
  invoiceSaveCompletePopup,
  invoiceIssueCompletePopup,
  isInvoiceInit,
  getMassiveIssuanceVerificationResult,
  updateMassiveIssuance,
  setMassiveInvoiceTempList,

  getClientList,
  setClientList,
  insertClientList,
  deleteClientList,
  updateClient,
  setUploadClientList,
  isClientDetailPopup,
  insertUploadClientList,
  initClientList,
  tradeRegisteredNameCheck,
  isTradeRegisteredNameCheck,
  tradeTinCheck,
  isTradeTinCheck,
  isTradeTin,

  getItemList,
  setItemList,
  insertItemList,
  deleteItemList,
  updateItem,
  setUploadItemList,
  isItemDetailPopup,
  insertUploadItemList,
  initItemList,
  itemNameCheck,
  isItemNameCheck,
  getClientStatus,

  getAdvisoryList,
  getAdvisoryDetail,
  insertAdvisoryList,
  initAdvisoryList,
  initAdvisoryDetail,
  setAdvisoryPage,
  getMainAdvisoryList,

  getBoardList,
  getBoardDetail,
  initBoardList,
  initBoardDetail,
  insertBoardPostList,
  setFaqPage,

  objectStorageUpload,
  objectStorageDownload,
  objectStorageDelete,
  objectStorageAlwaysDownloadUrl,

  findByAuthorization,
  insertUser,
  getEncryptPasswordKey,
  isTin,
  isTinBranchCodeChange,
  existId,
  destroySignUpElement,

  signIn,
  signOut,

  searchId,
  sendSearchIdMail,
  searchPw,
  sendSearchPwMail,

  changePassword,
  changePasswordByDialog,
  resetPassword,
  initUser,

  getUser,
  updateUser,

  initStatistics,
  getStatisticsSum,
  getStatisticsSumDetail,
  getStatisticsSumPopup,
  getStatisticsPeriod,
  getStatisticsPeriodDetail,
  getStatisticsPeriodPopup,
  getStatisticsType,
  isStatisticsSumPopup,
  isStatisticsPeriodPopup,

  initStatisticsPosCrm,
  getStatisticsPosCrmSum,
  getStatisticsPosCrmSumDetail,
  getStatisticsPosCrmSumPopup,
  getStatisticsPosCrmPeriod,
  getStatisticsPosCrmPeriodDetail,
  getStatisticsPosCrmPeriodPopup,
  getStatisticsPosCrmType,
  isStatisticsPosCrmSumPopup,
  isStatisticsPosCrmPeriodPopup,

  getCompany,
  getCompanyByTinAndBranchCode,
  initCompany,
  updateCompany,
  updateInvoiceSetting,

  deleteEmployee,
  inviteEmployee,

  searchUserList,
  changeUserStatus,

  initMail,

  initTaxpayerDetail,
  getTaxpayerDetail,

  initVatMonthlyList,
  initVatMonthlyDetail,
  initVatQuarterlyList,
  initVatQuarterlyDetail,
  getVatMonthlyList,
  getVatMonthlyDetail,
  getVatQuarterlyList,
  getVatQuarterlyDetail,

  initJWS,
  getJWS,
};
